import { render, staticRenderFns } from "./ImagesBox.vue?vue&type=template&id=ff0f93b6"
import script from "./ImagesBox.vue?vue&type=script&lang=js"
export * from "./ImagesBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports